<div *ngIf="show" class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Premium Header -->
    <div class="modal-header">
      <h2>Experience Synopsis</h2>
      <button (click)="onClose()" class="btn-close" title="Close Panel">&times;</button>
    </div>

    <!-- Modal Content -->
    <div *ngIf="event" class="modal-body !p-0">
      
      <!-- Event Hero Image -->
      <div class="w-full h-64 relative overflow-hidden bg-slate-100">
        <img [src]="event.image" 
             class="w-full h-full object-cover" 
             alt="Event Cover">
        <div class="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent"></div>
        <div class="absolute bottom-6 left-8 right-8">
           <span class="px-3 py-1 text-white text-[10px] font-black uppercase tracking-widest rounded-lg mb-3 inline-block shadow-lg"
                 [ngClass]="{
                   'bg-indigo-600': (event.type || event.category) === 'CONFERENCE',
                   'bg-emerald-600': (event.type || event.category) === 'NETWORKING',
                   'bg-fuchsia-600': (event.type || event.category) === 'WORKSHOP',
                   'bg-amber-600': (event.type || event.category) === 'WEBINAR',
                   'bg-slate-500': !['CONFERENCE', 'NETWORKING', 'WORKSHOP', 'WEBINAR'].includes(event.type || event.category)
                 }">
            {{ event.type || event.category || 'EVENT' }}
          </span>
          <h1 class="text-3xl font-black text-white tracking-tighter leading-tight">{{ event.name || event.title }}</h1>
        </div>
      </div>

      <div class="p-8">
        <!-- Primary Identity (moved to hero) -->
        <!-- <div class="status-track mb-8"> ... </div> -->


      <!-- Core Details Segment -->
      <div class="content-group">
        <span class="group-title">Engagement Logistics</span>
        <div class="info-grid">
          <div class="info-item">
            <label>Chronology</label>
            <div class="value font-bold text-slate-900">{{ formatEventDateTime(event) }}</div>
          </div>
          <div class="info-item">
            <label>Geographic Node</label>
            <div class="value">{{ event.location || event.venue }}</div>
          </div>
          <div class="info-item">
            <label>Load Factor</label>
            <div class="value">
              <span class="text-indigo-600 font-black">{{ event.totalRegisteredSeats !== undefined ? event.totalRegisteredSeats : (event.registeredCount || 0) }}</span> 
              / {{ event.capacity || event.maxCapacity || '∞' }}
            </div>
          </div>
          <div class="info-item">
            <label>Status</label>
            <div class="value text-[10px] font-black uppercase text-emerald-500 tracking-widest shadow-sm px-2 py-1 bg-emerald-50 rounded-lg inline-block">LIVE REGISTRATION</div>
          </div>
        </div>
      </div>

      <!-- Narrative Segment -->
      <div class="content-group">
        <span class="group-title">Executive Summary</span>
        <div class="value text-sm leading-relaxed text-slate-600 whitespace-pre-line">{{ event.description || event.shortDescription || event.fullDescription }}</div>
      </div>

      <!-- Financial Commitment Segment -->
      <div class="content-group border-indigo-100 bg-indigo-50/30">
        <span class="group-title text-indigo-400">Financial Valuation</span>
        <div *ngIf="getTicketTypes().length && !getVisibleTicketTypes().length" class="mb-4 rounded-xl border border-amber-200 bg-amber-50/80 px-3 py-2 text-[11px] font-bold text-amber-800">
          No ticket options are available for your current membership. You can still review event details above.
        </div>
        <div *ngIf="getVisibleTicketTypes().length" class="mb-4">
          <label class="text-[10px] font-black text-indigo-300 uppercase mb-2 block">Your ticket options</label>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-2">
            <button type="button"
                    *ngFor="let ticket of getVisibleTicketTypes()"
                    (click)="selectTicket(ticket)"
                    class="text-left px-3 py-2 rounded-xl border transition"
                    [ngClass]="{
                      'border-indigo-500 bg-white': selectedTicketTypeId === ticket.id,
                      'border-slate-200 bg-slate-50': selectedTicketTypeId !== ticket.id
                    }">
              <div class="flex items-center justify-between gap-2">
                <span class="text-xs font-black text-slate-900">{{ ticket.name || ticket.type }}</span>
                <span class="text-[10px] font-black uppercase"
                      [ngClass]="{
                        'text-emerald-600': getTicketStatus(ticket) === 'Available',
                        'text-amber-600': getTicketStatus(ticket) === 'Few left',
                        'text-rose-600': getTicketStatus(ticket) === 'Sold out' || getTicketStatus(ticket) === 'Closed',
                        'text-slate-400': getTicketStatus(ticket) === 'Not eligible'
                      }">
                  {{ getTicketStatus(ticket) }}
                </span>
              </div>
              <div class="flex items-center justify-between mt-1">
                <span class="text-[10px] font-black uppercase text-slate-400">Price</span>
                <span class="text-[11px] font-bold text-indigo-600">{{ ticket.price === 0 ? 'Free' : ('₹' + (ticket.price | number:'1.0-0')) }}</span>
              </div>
              <div class="flex items-center justify-between mt-1" *ngIf="ticket.availableQuantity != null">
                <span class="text-[10px] font-black uppercase text-slate-400">Quantity Left</span>
                <span class="text-[10px] text-slate-500">{{ ticket.availableQuantity }}</span>
              </div>
              <div class="flex items-center justify-between mt-1" *ngIf="ticket.type === 'EARLY_BIRD' && event?.earlyBirdEndDate">
                <span class="text-[10px] font-black uppercase text-slate-400">Ends On</span>
                <span class="text-[10px] text-slate-500">{{ event.earlyBirdEndDate | date:'dd MMM yyyy' }}</span>
              </div>
            </button>
          </div>
          <div *ngIf="getSelectedTicketReason()" class="mt-2 text-[11px] font-bold text-amber-600">
            {{ getSelectedTicketReason() }}
          </div>
        </div>
        <div class="flex items-end justify-between">
          <div>
            <label class="text-[10px] font-black text-indigo-300 uppercase mb-1 block">Unit Price (Base)</label>
            <div class="value-large text-indigo-600">{{ getEventCost() }}</div>
          </div>
          
          <div class="flex flex-col items-end gap-2">
            <label class="text-[10px] font-black text-indigo-300 uppercase">Magnitude</label>
            <div class="flex items-center gap-1 bg-white p-1 rounded-xl shadow-sm border border-indigo-100">
              <button (click)="decreaseQuantity()" [disabled]="quantity <= 1" class="w-8 h-8 rounded-lg text-indigo-600 hover:bg-indigo-50 disabled:opacity-20 font-black">−</button>
              <input type="number" [(ngModel)]="quantity" min="1" [max]="getMaxQuantity()" class="w-10 text-center font-black text-xs text-slate-900 focus:outline-none" (change)="validateQuantity()">
              <button (click)="increaseQuantity()" [disabled]="quantity >= getMaxQuantity()" class="w-8 h-8 rounded-lg text-indigo-600 hover:bg-indigo-50 disabled:opacity-20 font-black">+</button>
            </div>
          </div>
        </div>
        <div class="mt-4 pt-4 border-t border-indigo-100 flex justify-between items-center">
            <span class="text-[10px] font-black text-indigo-400 uppercase">Committing Value</span>
            <span class="text-sm font-black text-indigo-600 tracking-tight">{{ getTotalPrice() }}</span>
        </div>
      </div>

      <!-- Specialized Modules (Speakers/Schedule) -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
        <div *ngIf="event?.speakers?.length">
          <span class="group-title px-2">Voice & Authority</span>
          <div class="space-y-3">
            <div *ngFor="let s of event.speakers" class="flex items-center gap-3 p-3 bg-white border border-slate-100 rounded-2xl shadow-sm">
              <div class="w-10 h-10 rounded-xl bg-indigo-600 text-white flex items-center justify-center font-black text-sm">
                {{ (s.name || 'S')[0] }}
              </div>
              <div>
                <p class="text-xs font-black text-slate-900 tracking-tight">{{ s.name }}</p>
                <p class="text-[9px] font-bold text-slate-400 uppercase">{{ s.title }}</p>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="event?.schedules?.length">
          <span class="group-title px-2">Agenda Sequence</span>
          <div class="space-y-3">
            <div *ngFor="let item of event.schedules" class="flex gap-3 p-3 bg-white border border-slate-100 rounded-2xl shadow-sm">
              <div class="text-[9px] font-black text-indigo-600 uppercase w-16 pt-0.5">
                {{ formatScheduleTime(item.startTime) }}
              </div>
              <div class="flex-1">
                <p class="text-xs font-black text-slate-900 tracking-tight">{{ item.title || 'Session' }}</p>
                <p class="text-[9px] font-bold text-slate-400">{{ item.location }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Admin Intelligence Module (Attendance) -->
      <div *ngIf="canManageAttendance()" class="attendance-track">
        <div class="flex items-center justify-between mb-4 px-2">
          <span class="text-sm font-black text-slate-900 uppercase tracking-widest">Attendance Registry</span>
          <button (click)="toggleAttendance()" class="btn-pill btn-secondary text-[10px] py-1.5">
            {{ showAttendance ? 'Hide Registry' : 'Extract Registry' }}
          </button>
        </div>

        <div *ngIf="showAttendance" class="animate-reveal">
          <div *ngIf="isLoadingAttendees" class="py-12 text-center text-[10px] font-black text-slate-400 uppercase tracking-widest">Synchronizing Nodes...</div>
          <div *ngIf="!isLoadingAttendees && attendees.length > 0" class="scroll-track shadow-inner bg-slate-50/50">
            <table>
              <thead>
                <tr>
                  <th>Identity</th>
                  <th>Ticket</th>
                  <th>Status</th>
                  <th>Attendance</th>
                  <th class="text-right">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let a of attendees">
                  <td class="font-bold">{{ a.userEmail }}</td>
                  <td class="text-[10px] font-black text-slate-400 uppercase">{{ a.ticketTypeName }}</td>
                  <td class="text-center">
                    <span class="px-2 py-0.5 rounded-lg text-[9px] font-black" [ngClass]="a.status === 'CONFIRMED' ? 'bg-emerald-50 text-emerald-600' : 'bg-slate-100 text-slate-400'">{{ a.status }}</span>
                  </td>
                  <td>
                    <span class="text-[10px] font-black uppercase" [class]="a.checkedIn ? 'text-indigo-600' : 'text-slate-300'">{{ a.checkedIn ? 'SECURED' : 'PENDING' }}</span>
                  </td>
                  <td class="text-right">
                    <button *ngIf="!a.checkedIn" (click)="markAttendance(a)" class="text-[10px] font-black text-indigo-600 hover:underline">AUTHORIZE</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="flex gap-4 mt-10">
        <button *ngIf="!isEventClosed()" (click)="onRegister()" [disabled]="isRegistering || isUserRegistered() || !canProceedRegistration()" 
                class="btn-pill btn-primary py-4"
                [class.btn-disabled]="isUserRegistered()">
          {{ getRegisterButtonText() }}
        </button>
        <button (click)="onClose()" class="btn-pill btn-secondary px-10">Dismiss</button>
      </div>
    </div>
  </div>
</div>
